import { render, staticRenderFns } from "./vw-flat-rate-import-view.vue?vue&type=template&id=5bfb3596&scoped=true&"
import script from "./vw-flat-rate-import-view.vue?vue&type=script&lang=js&"
export * from "./vw-flat-rate-import-view.vue?vue&type=script&lang=js&"
import style0 from "./vw-flat-rate-import-view.vue?vue&type=style&index=0&id=5bfb3596&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfb3596",
  null
  
)

export default component.exports